import { gql } from '@apollo/client'
import React from 'react'

import { accountsClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext()
const { Provider } = Context
export const useProfilesState = () => React.useContext(Context) || {}
export const useProfiles = () => useProfilesState()?.profiles || []

const QUERY = gql`
  query Profiles {
    profiles(sort: { field: ID, type: ASC }, limit: 99999) {
      id
      name
      label
    }
  }
`

const ProfilesLoader = ({ children }) => {
  const { data, ...state } = useQuery(QUERY, {
    client: accountsClient
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state}>{children}</StatePresenter>
    </Provider>
  )
}

export default ProfilesLoader
